import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UserCard from "../../components/UserDesc/UserCard";
import PayForm from "../../components/PayForm/PayForm";
import axios from "axios";
import "./checkout.css";
import errorSign from "../../assets/images/warning-hex-svgrepo-com.svg";
import UserCardSkeleton from "../../components/UserDesc/UserCardSkeleton";

const Checkout = () => {
  const { uniqueCode } = useParams("uniqueCode");
  console.log(uniqueCode);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  // ========== fetching page data ================
  const [paymentData, setPaymentData] = useState(null);
  const [errorState, setErrorState] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        setLoading(true);
        const resp = await axios.get(
          `${BACKEND_URL}/api/paymentLinks/link/${uniqueCode}`
        );
        console.log(resp.data.data);
        setPaymentData(resp.data.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setErrorState(true);
      }
    };
    fetchPaymentData();
  }, []);

  let content;

  if (loading) {
    content = (
      <div className="max-w-[1200px] h-full mx-1 mb-5 sm:mx-auto flex flex-wrap gap-4">
        <UserCardSkeleton />
        <PayForm />
      </div>
    );
  }
  if (errorState) {
    content = (
      <div className="bg-white flex flex-col justify-center items-center p-4 sm:p-6 gap-2 max-w-[400px] shadow-xl border border-gray-200 rounded-lg text-[#4e1c4e] mx-2 sm:mx-auto my-8 sm:my-12">
        <img className="w-16" src={errorSign} alt="Error" />
        <h1 className="text-2xl font-bold text-center">
          Oops! Something went wrong.
        </h1>
        <p className="text-center px-2 sm:px-4">
          We couldn't load the payment information. Please try again or contact
          support if the issue persists.
        </p>
        <button
          className="bg-[#4e1c4e] text-gray-50 py-1.5 font-medium text-center rounded-lg w-full max-w-[250px] mt-2"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }
  if (paymentData) {
    content = (
      <div className="max-w-[1200px] h-full mb-5 sm:mx-auto flex flex-wrap items-center ">
        <div className="w-full px-2 mb-5 sm:mx-auto flex flex-wrap gap-4">
          <UserCard paymentData={paymentData} />
          <PayForm
            paymentData={paymentData}
            amount={paymentData.defaultAmount}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="relative md:h-[700px]">
      <div className="checkout-blob absolute h-[400px] w-3/4 z-[-1] top-8"></div>
      <div className="w-full h-full">{content}</div>
    </div>
  );
};

export default Checkout;
